import { useState } from 'react';
import { useStandardPickerCategory } from '../../achievement-standard-picker/context/StandardPickerCategoryProvider';
import { useAvailableSubjects } from '../hooks/useAvailableSubjects';
import type { GradeOption } from '../hooks/useGradeOptions';
import { GradeFilter } from './GradeFilter';
import { SubjectFilter } from './SubjectFilter';
interface SearchFilterBarProps {
  gradeOptions: GradeOption[];
  state: {
    gradeOption: GradeOption | null;
    subjectGroupId: string | null;
    isSubjectDisabled: boolean;
  };
  onGradeChange: (gradeOption: GradeOption) => void;
  onSubjectChange: (subjectGroupId: string) => void;
}

/**
 * 학년 + 과목 필터를 가로로 배치하는 필터바 컴포넌트 (Controlled Component)
 *
 * open 상태를 통합 관리하여 두 드롭다운이 동시에 열리는 현상을 방지.
 * (모바일 터치 환경에서 Radix outside-click이 다른 트리거를 감지 못하는 문제 대응)
 */
export const SearchFilterBar = ({
  gradeOptions,
  state,
  onGradeChange,
  onSubjectChange
}: SearchFilterBarProps) => {
  const categoryContext = useStandardPickerCategory();
  const {
    subjectTree
  } = categoryContext;
  const subjectOptions = useAvailableSubjects(state.gradeOption?.ids || null, subjectTree);
  const [openFilter, setOpenFilter] = useState<'grade' | 'subject' | null>(null);
  return <div className="flex flex-row gap-2xs" data-sentry-component="SearchFilterBar" data-sentry-source-file="SearchFilterBar.tsx">
      <GradeFilter options={gradeOptions} value={state.gradeOption} onChange={onGradeChange} open={openFilter === 'grade'} onOpenChange={open => setOpenFilter(open ? 'grade' : null)} data-sentry-element="GradeFilter" data-sentry-source-file="SearchFilterBar.tsx" />
      <SubjectFilter value={state.subjectGroupId} onChange={onSubjectChange} options={subjectOptions} disabled={state.isSubjectDisabled} open={openFilter === 'subject'} onOpenChange={open => setOpenFilter(open ? 'subject' : null)} data-sentry-element="SubjectFilter" data-sentry-source-file="SearchFilterBar.tsx" />
    </div>;
};